import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentmumbai() {



  const cardData =
  {
    keyword: 'Tempo Traveller On Rent Mumbai ',
    heading: 'Shambhu Cabs: Tempo Traveller On Rent Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Tempo Traveller On Rent in Mumbai, providing safe, comfortable, and spacious travel for large groups, families, corporate teams, and tourists. Our well-maintained tempo travellers ensure a smooth and enjoyable journey with ample seating and luggage space, ideal for airport transfers, outstation trips, city tours, and special occasions. With professional chauffeurs, flexible one-way and round-trip rental options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes group travel convenient, stress-free, and comfortable. For safety, reliability, and a hassle-free travel experience, Shambhu Cabs is your trusted choice for Tempo Traveller on rent in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch commemorating the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time and symbolizes Mumbai’s urban growth. Sunrise, sunset, and nighttime views with illuminated cables provide spectacular photographic opportunities."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, one of India’s oldest and most famous flea markets, is renowned for antiques, vintage Bollywood memorabilia, gramophones, cameras, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, designers, and collectors explore the market to discover unique treasures. The chaotic yet vibrant atmosphere makes it an exciting spot for cultural enthusiasts and photographers."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park spans over 100 sq km in northern Mumbai, serving as a biodiversity hotspot and city escape. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling, and trekking. The ancient Kanheri Caves within the park provide historical and archaeological interest. Home to leopards, monkeys, deer, and hundreds of bird species, it offers a jungle retreat in the middle of the city, perfect for adventure and nature enthusiasts."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is a Roman Catholic church atop a hill in Bandra. Known for its Gothic architecture, peaceful interiors, and panoramic views of the sea, it attracts devotees and tourists alike. The annual Bandra Fair in September draws large crowds for prayers, cultural programs, and local food. The church symbolizes Mumbai’s religious harmony and cultural diversity."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda in Gorai is a massive meditation hall and a monument to peace. Featuring the world’s largest stone dome built without supporting pillars, it serves as a center for learning Vipassana meditation. The pagoda’s serene atmosphere, golden interiors, and scenic gardens attract spiritual seekers and tourists. Visitors gain insight into India’s meditation traditions while enjoying panoramic views of the surrounding landscapes."
  }
],



"services": [
  {
    "name": "Tempo Traveller Hire Mumbai",
    "description": "Tempo Traveller Hire Mumbai provides spacious and comfortable travellers for group travel within the city or for long-distance trips. Ideal for families, corporate outings, and airport transfers with professional drivers and AC options."
  },
  {
    "name": "12-Seater Traveller Mumbai",
    "description": "12-Seater Traveller Mumbai offers compact group transport for small families or teams. Perfect for city trips, airport pickups, and short outstation journeys with reliable service and comfortable seating."
  },
  {
    "name": "17-Seater Tempo Mumbai",
    "description": "17-Seater Tempo Mumbai caters to medium-sized groups for city tours, corporate events, and outstation travel. Equipped with AC and spacious interiors for a comfortable journey."
  },
  {
    "name": "Traveller for Outstation Mumbai",
    "description": "Traveller for Outstation Mumbai provides long-distance travel solutions for large groups. Comfortable seating, AC options, and professional chauffeurs ensure a safe and smooth outstation trip."
  },
  {
    "name": "AC Tempo Traveller Mumbai",
    "description": "AC Tempo Traveller Mumbai offers air-conditioned group transport for city and outstation travel. Ideal for family trips, corporate events, and airport transfers, ensuring comfort and convenience."
  },
  {
    "name": "Luxury Tempo Mumbai",
    "description": "Luxury Tempo Mumbai provides high-end travellers for premium group travel experiences. Equipped with modern interiors, AC, and professional drivers for a seamless journey."
  },
  {
    "name": "Family Group Traveller Mumbai",
    "description": "Family Group Traveller Mumbai offers spacious travellers for family outings, picnics, and long-distance trips. Comfortable seating and reliable service ensure a safe and enjoyable ride."
  },
  {
    "name": "Corporate Traveller Mumbai",
    "description": "Corporate Traveller Mumbai caters to office outings, corporate events, and business trips. Professional drivers, timely service, and comfortable AC travellers enhance the corporate travel experience."
  },
  {
    "name": "Airport Traveller Mumbai",
    "description": "Airport Traveller Mumbai provides convenient airport pickups and drops in spacious travellers. Comfortable seating, AC, and punctual service make it ideal for large groups traveling to or from Mumbai airports."
  },
  {
    "name": "Affordable Tempo Hire Mumbai",
    "description": "Affordable Tempo Hire Mumbai offers cost-effective solutions for group travel. Perfect for local trips, family outings, and short outstation journeys without compromising comfort or safety."
  },
  {
    "name": "Tourist Traveller Booking Mumbai",
    "description": "Tourist Traveller Booking Mumbai specializes in group transport for sightseeing and tourist trips. AC travellers with professional drivers ensure a smooth and enjoyable travel experience."
  },
  {
    "name": "Big Vehicle Rental Mumbai",
    "description": "Big Vehicle Rental Mumbai provides large travellers and buses for big groups. Suitable for long trips, corporate events, and family excursions with comfort and safety guaranteed."
  },
  {
    "name": "Traveller for Picnic Mumbai",
    "description": "Traveller for Picnic Mumbai offers spacious vehicles for group picnic trips. Comfortable seating, AC options, and reliable service make it perfect for family and friends outings."
  },
  {
    "name": "Group Travel Vehicle Mumbai",
    "description": "Group Travel Vehicle Mumbai caters to small to large group travel requirements. Ideal for city tours, outstation trips, and airport transfers with AC and non-AC options."
  },
  {
    "name": "Mumbai Traveller Booking 24×7",
    "description": "Mumbai Traveller Booking 24×7 allows instant booking of travellers anytime. Perfect for last-minute trips, outstation travel, and airport transfers with professional drivers and reliable service."
  },
  {
    "name": "Long Trip Tempo Traveller",
    "description": "Long Trip Tempo Traveller provides comfortable and spacious vehicles for long-distance travel. Equipped with AC, ample luggage space, and professional chauffeurs for safe journeys."
  },
  {
    "name": "Comfortable Traveller Hire",
    "description": "Comfortable Traveller Hire Mumbai offers spacious and smooth rides for group travel. Perfect for family outings, corporate trips, and tourist excursions with AC and professional drivers."
  }
],

"tableData": [
  ["Tempo Traveller Hire Mumbai", "12-Seater Traveller Mumbai"],
  ["17-Seater Tempo Mumbai", "Traveller for Outstation Mumbai"],
  ["AC Tempo Traveller Mumbai", "Luxury Tempo Mumbai"],
  ["Family Group Traveller Mumbai", "Corporate Traveller Mumbai"],
  ["Airport Traveller Mumbai", "Affordable Tempo Hire Mumbai"],
  ["Tourist Traveller Booking Mumbai", "Big Vehicle Rental Mumbai"],
  ["Traveller for Picnic Mumbai", "Group Travel Vehicle Mumbai"],
  ["Mumbai Traveller Booking 24×7", "Long Trip Tempo Traveller"],
  ["Comfortable Traveller Hire", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Tempo Traveller On Rent in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers Tempo Traveller on rent in Mumbai, perfect for group trips, family outings, corporate travel, and comfortable intercity journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Tempo Travellers",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced Tempo Travellers to ensure a smooth and comfortable ride for large groups."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Group Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai and surrounding routes, ensuring safe, timely, and hassle-free travel in a Tempo Traveller."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your Tempo Traveller rental stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your Tempo Traveller travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Tempo Traveller rental in Mumbai convenient and worry-free."
  }
]
















  }

const faqData = [
  {
    question: 'Can I rent a Tempo Traveller in Mumbai with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs provides Tempo Traveller on rent in Mumbai for group travel, family trips, corporate outings, and outstation journeys.',
  },
  {
    question: 'How can I book a Tempo Traveller on rent in Mumbai?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for a quick and hassle-free booking.',
  },
  {
    question: 'Is Tempo Traveller suitable for group travel in Mumbai?',
    answer: 'Absolutely. Tempo Travellers are ideal for large families or groups, offering spacious seating and comfort for long city or outstation trips.',
  },
  {
    question: 'Are drivers experienced for Tempo Traveller rentals in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Mumbai routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for Tempo Traveller rental?',
    answer: 'Yes, you can select any pickup and drop-off points within Mumbai or for outstation trips according to your convenience.',
  },
  {
    question: 'Is Tempo Traveller rental available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock Tempo Traveller rental services to accommodate any travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Tempo Traveller rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety measures to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for Tempo Traveller rental in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for Tempo Traveller bookings.',
  },
  {
    question: 'Is customer support available during Tempo Traveller rental trips in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Tempo Traveller rental journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehra',
    feedback: 'Renting a Tempo Traveller from Shambhu Cabs in Mumbai was perfect for our family trip. Spacious seating and professional driver made the journey smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kapoor',
    feedback: 'Highly recommend Shambhu Cabs for Tempo Traveller rentals in Mumbai. Excellent service and comfortable ride for our group outing.',
    rating: 5,
  },
];
































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/tempo-traveller-mumbai.jpg",
  "description": "Shambhu Cabs offers Tempo Traveller rentals in Mumbai, including 12-seater and 17-seater vehicles. Ideal for family trips, corporate travel, airport transfers, outstation journeys, picnics, and group tours. Comfortable, AC and non-AC options available with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/tempo-traveller-rental-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Tempo Traveller On Rent in Mumbai | 12 & 17 Seater | Shambhu Cabs</title>

  <meta
    name="description"
    content="Rent a Tempo Traveller in Mumbai with Shambhu Cabs. 12-seater and 17-seater options available for family trips, corporate travel, airport transfers, outstation journeys, picnics, and group tours. Comfortable AC and non-AC travellers with professional drivers."
  />

  <meta
    name="keywords"
    content="Tempo Traveller Hire Mumbai, 12-Seater Traveller Mumbai, 17-Seater Tempo Mumbai, Traveller for Outstation Mumbai, AC Tempo Traveller Mumbai, Luxury Tempo Mumbai, Family Group Traveller Mumbai, Corporate Traveller Mumbai, Airport Traveller Mumbai, Affordable Tempo Hire Mumbai, Tourist Traveller Booking Mumbai, Big Vehicle Rental Mumbai, Traveller for Picnic Mumbai, Group Travel Vehicle Mumbai, Mumbai Traveller Booking 24×7, Long Trip Tempo Traveller, Comfortable Traveller Hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentmumbai;